import { type UseMutationResult, useMutation } from '@tanstack/react-query'
import {
  type RequestError,
  extractHttpError,
} from 'components/api/extractHttpError'
import { API_PREFIX } from 'config'
import ky from 'ky'

import { logEvents } from '../../logEvents'

type Response = {
  uid: string
  organizationUid: string
  puzzelSessionUid: string
  created: string
  text: string
  metadata: Record<string, string>
}

export type LiveSummaryPayload = {
  puzzelSessionUid: string
  text: string
  metadata: {
    queueKey?: string
    agentUserName?: string
  }
}

export const useSaveLiveSummary = (
  apiToken: string,
): UseMutationResult<Response, RequestError, LiveSummaryPayload> =>
  useMutation({
    mutationFn: async (payload) => {
      try {
        return await ky
          .post(`${API_PREFIX}/co-pilot/v1/summaries?token=${apiToken}`, {
            json: payload,
            credentials: 'include',
            mode: 'cors',
            headers: {
              Authorization: apiToken,
            },
            timeout: 30_000, // 30 seconds
          })
          .json<Response>()
      } catch (error) {
        const e = await extractHttpError(error)
        logEvents({
          eventType: 'useSaveLiveSummary error',
          level: 'error',
          name: e.name,
          message: e.message,
          ...e.cause,
        })

        throw e
      }
    },
  })
